import React, { useContext, useState } from 'react';

import { HStack, Text } from '@chakra-ui/react';

import MaskedSsnButton from './MaskedSsnButton';
import { SsnMask } from './MaskedSsnCustomerInfo';

import { PermissionEnum } from '../../constants/permissions';
import { useUser } from '../../hooks/useUser';
import { AbilityContext } from '../../libs/contextLib';

interface MaskedSsnPayoffProps {
  claimedBy?: string;
  customerId?: number;
  tempInfoId?: number | null;
}

const MaskedSsnPayoff: React.FC<MaskedSsnPayoffProps> = ({ claimedBy, customerId, tempInfoId }) => {
  const [ssn, setSsn] = useState('');
  const [ssnHidden, setSsnHidden] = useState(true);
  const ability = useContext(AbilityContext);
  const user = useUser();
  const canViewSsn =
    ability.has(PermissionEnum.SuperUser) ||
    ability.has(PermissionEnum.PayoffManager) ||
    claimedBy === user.id;

  const handleClick = (value: boolean, newSsn: string) => {
    setSsn(newSsn);
    setSsnHidden(value);
  };

  return (
    <HStack maxWidth="100%" spacing="auto">
      {ssnHidden ? (
        <SsnMask type="payoff" />
      ) : (
        <Text minWidth="96px" mr="18px">
          {ssn}
        </Text>
      )}
      <MaskedSsnButton
        type="payoff"
        customerId={customerId}
        tempInfoId={tempInfoId}
        onClick={handleClick}
        visible={canViewSsn}
      />
    </HStack>
  );
};

export default MaskedSsnPayoff;
